import { render, staticRenderFns } from "./MultiSelectWidget.vue?vue&type=template&id=b238d478"
import script from "./MultiSelectWidget.vue?vue&type=script&lang=js"
export * from "./MultiSelectWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports